import Card from "@mui/material/Card";
import { MenuItem, Select } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import PaginationBar from "components/PaginationBar/PaginationBar";
import Dropdown from "components/CustomDropdown/Dropdown";
import { useEffect, useState } from "react";
import useOtpLogsTableData from "Views/Communication/OtpLogs/data/otpLogsTableData";

function OtpLogs() {
  const [phoneQuery, setPhoneQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [refresh, setRefresh] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    setCurrentPage(1);
  }, [phoneQuery, typeFilter]);

  const { columns, rows, loading, totalItems, totalPages, refetch } = useOtpLogsTableData(
    currentPage,
    rowsPerPage,
    phoneQuery,
    typeFilter,
    refresh
  );

  const handlePageChange = (event, page) => setCurrentPage(page);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setRefresh((prev) => !prev);
    refetch();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between">
                <ArgonTypography variant="h6">OTP Logs</ArgonTypography>

                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox sx={{ width: "220px" }}>
                    <ArgonInput
                      placeholder="Search by phone"
                      name="phone"
                      size="small"
                      type="text"
                      variant="outlined"
                      value={phoneQuery}
                      onChange={(event) => setPhoneQuery(event.target.value)}
                    />
                  </ArgonBox>

                  <ArgonBox display="flex" alignItems="center" gap={2}>
                    <Dropdown
                      value={typeFilter}
                      options={[
                        { label: "All Types", value: "" },
                        { label: "Parent", value: "Parent" },
                        { label: "Tutor", value: "Tutor" },
                      ]}
                      onChange={(e) => setTypeFilter(e.target.value)}
                      width={150}
                    />
                  </ArgonBox>

                  <ArgonButton variant="gradient" color="info" size="small" onClick={handleRefresh}>
                    Refresh
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {loading ? (
                <ArgonBox textAlign="center" py={4}>
                  <ArgonTypography variant="h6" color="text" fontWeight="medium">
                    Fetching OTP logs...
                  </ArgonTypography>
                  <ArgonTypography variant="caption" color="secondary">
                    Please wait while we load the latest data.
                  </ArgonTypography>
                </ArgonBox>
              ) : rows.length > 0 ? (
                <Table columns={columns} rows={rows} />
              ) : (
                <ArgonBox textAlign="center" py={4}>
                  <ArgonTypography variant="h6" color="text" fontWeight="medium">
                    {phoneQuery || typeFilter
                      ? "No OTP logs found for the selected filters"
                      : "No OTP logs found"}
                  </ArgonTypography>
                  <ArgonTypography variant="caption" color="secondary">
                    {phoneQuery || typeFilter
                      ? "Try adjusting your filters."
                      : "No OTP log data available."}
                  </ArgonTypography>
                </ArgonBox>
              )}
            </ArgonBox>

            {totalItems > 0 && (
              <PaginationBar
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalItems={totalItems}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            )}
          </Card>
        </ArgonBox>
      </ArgonBox>

      <Footer />
    </DashboardLayout>
  );
}

export default OtpLogs;
